'use strict';

var cov_1dqnlevuu5 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/workspaceDetails/workspaceDetails.js',
        hash = 'a1efa1d31154ac41feca29b7e1451337e7c0bf92',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/workspaceDetails/workspaceDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 31
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 0
                },
                end: {
                    line: 16,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 20
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WorkspaceDetailsController = function () {
    function WorkspaceDetailsController() {
        _classCallCheck(this, WorkspaceDetailsController);
    }

    _createClass(WorkspaceDetailsController, [{
        key: 'saveWorkspace',
        value: function saveWorkspace() {
            cov_1dqnlevuu5.f[0]++;
            cov_1dqnlevuu5.s[0]++;

            this.workspace.$save();
        }
    }]);

    return WorkspaceDetailsController;
}();

cov_1dqnlevuu5.s[1]++;


angular.module('app').component('workspaceDetails', {
    templateUrl: 'app/components/workspaceDetails/workspaceDetails.html',
    controller: WorkspaceDetailsController,
    bindings: {
        workspace: '<'
    }
});